// extracted by mini-css-extract-plugin
export default {"pageWrap":"cd-z","fullWidth":"dd-z","heading":"ed-z","fullBleed":"fd-z","hidden":"gd-z"};